import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { getNextItemIndex } from '@/utils/array';
import { SHARP_TENSION, SMOOTH_TENSION } from '@/components/widget/utils/tension';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import { jsx as _jsx } from "react/jsx-runtime";

var SmoothLineIcon = function SmoothLineIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.1205 0.0663248C17.7942 0.290863 18.1582 1.01896 17.9337 1.69258L15.3923 9.31656C14.4857 12.0366 11.0334 12.8516 9.00597 10.8242L7.17582 8.99402C6.50001 8.31821 5.34926 8.58987 5.04703 9.49656L2.5057 17.1205C2.28116 17.7942 1.55307 18.1582 0.87945 17.9337C0.205835 17.7091 -0.158214 16.981 0.0663248 16.3074L2.60765 8.68344C3.51435 5.96335 6.9666 5.14839 8.99402 7.17582L10.8242 9.00597C11.5 9.68178 12.6507 9.41013 12.953 8.50344L15.4943 0.87945C15.7188 0.205835 16.4469 -0.158214 17.1205 0.0663248Z",
      fill: "#3A3D4D"
    })
  }));
};

SmoothLineIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var SharpLineIcon = function SharpLineIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 17L6 6.5L12.2941 11.6667L17 1",
      stroke: "#3A3D4D",
      strokeWidth: "2",
      strokeLinecap: "round"
    })
  }));
};

SharpLineIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const OPTIONS = [{
  value: SMOOTH_TENSION,
  label: 'Smooth',
  icon: /*#__PURE__*/_jsx(SmoothLineIcon, {})
}, {
  value: SHARP_TENSION,
  label: 'Sharp',
  icon: /*#__PURE__*/_jsx(SharpLineIcon, {})
}];

const EditorFieldsTension = _ref => {
  let {
    tension,
    defaultTension = SHARP_TENSION,
    openButtonVariant,
    onChange
  } = _ref;
  const currentTension = tension ?? defaultTension;
  const currentTensionOptionIdx = OPTIONS.findIndex(option => option.value === currentTension);
  const currentTensionOption = OPTIONS[currentTensionOptionIdx];
  return /*#__PURE__*/_jsx(RevealPill, {
    label: "Smoothness",
    disableOpen: true,
    activeState: currentTensionOption.icon,
    openButtonVariant: openButtonVariant,
    onOpenChange: () => {
      const nextOptionIdx = getNextItemIndex(currentTensionOptionIdx, OPTIONS.length);
      onChange({
        tension: OPTIONS[nextOptionIdx].value
      });
    }
  });
};

export default EditorFieldsTension;